export default __webpack_public_path__ + "static/1367-e36a6191ee315b2627736fc68af778f5.jpeg";